<template>
  <div>
    <el-row>
      <el-col :span="6">
        <span>学期优惠:</span>
      </el-col>
      <el-col :span="18">
        <span>{{dataIn.discountName}}</span>
      </el-col>
    </el-row>
    <el-row v-if="dataIn.memberCardModel.hasBuyMemberCard">
      <el-col :span="6">
        <span>购买会员:</span>
      </el-col>
      <el-col :span="18">
        <span>C{{dataIn.memberCardModel.memberCardDiscountPrice|toCurrency}}</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="6">
        <span>课程数量:</span>
      </el-col>
      <el-col :span="18">
        <span>{{dataIn.courseList.length}}</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="6">
        <span>课程原价:</span>
      </el-col>
      <el-col :span="18">
        <span class="cs-text-line-through">C{{dataIn.courseOriginalPrice|toCurrency}}</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="6">
        <span>课程价格:</span>
      </el-col>
      <el-col :span="18">
        <el-row v-for="(item, index) in sortedCourseList" :key="index">
          <el-col :span="10">
            <span>{{item.courseName}}</span>
            <span v-if="item.isRefund" class="cs-redLabel">(退课)</span>
          </el-col>
          <el-col :span="14">
            <div>
              <span>C{{(item.priceData.discountPrice)|toCurrency}}</span>
              <span>(-{{(item.priceData.price - item.priceData.discountPrice)|toCurrency}})</span>
              <span>{{calculateDiscount(item.priceData.price, item.priceData.discountPrice)}}</span>
            </div>
            <div v-if="dataIn.hasCouponDiscount">
              <span>代理 C{{(item.priceData.couponDiscountPrice)|toCurrency}}</span>
              <span>(-{{(item.priceData.discountPrice - item.priceData.couponDiscountPrice)|toCurrency}})</span>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="6">
        <span>课程总价:</span>
      </el-col>
      <el-col :span="18">
        <span>C{{courseTotalDiscountPrice|toCurrency}}</span>
      </el-col>
    </el-row>
    <el-row v-if="dataIn.hasCouponDiscount">
      <el-col :span="6">
        <span>代理折后课程总价:</span>
      </el-col>
      <el-col :span="18">
        <span>C{{courseTotalCouponDiscountPrice|toCurrency}}</span>
      </el-col>
    </el-row>
    <el-row v-if="dataIn.courseType == 1 && dataIn.supplementVideoTotalPrice> 0">
      <el-col :span="6">
        <span>补看视频总价:</span>
      </el-col>
      <el-col :span="18">
        <span>C{{dataIn.supplementVideoTotalPrice|toCurrency}}</span>
      </el-col>
    </el-row>
    <el-row class="cs-redLabel">
      <el-col :span="6" >
        <span>额外优惠:</span>
      </el-col>
      <el-col :span="18">
        <span>-C{{dataIn.courseTotalDecreaseAmount|toCurrency}}</span>
      </el-col>
    </el-row>
    <el-row class="cs-redLabel" v-if="!!dataIn.workflowRelatedDicountAmount">
      <el-col :span="6" >
        <span v-if="dataIn.workflowRelatedDicountAmount >= 0">课程连报关联优惠:</span>
        <span v-else>课程连报差价:</span>
      </el-col>
      <el-col :span="18">
        <span v-if="dataIn.workflowRelatedDicountAmount >= 0">-C{{dataIn.workflowRelatedDicountAmount|toCurrency}}</span>
        <span v-else>C{{-dataIn.workflowRelatedDicountAmount|toCurrency}}</span>
        <el-tooltip v-if="!!dataIn.workflowRelatedDicountDetail" class="item" effect="dark" placement="top">
          <div slot="content" v-html="dataIn.workflowRelatedDicountDetail"></div>
          <i class="fa fa-info-circle" aria-hidden="true"></i>
        </el-tooltip>
      </el-col>
    </el-row>

    <el-row v-if="!!dataIn.changeCourseDifferentPriceTotal && !isSupplement">
      <el-col :span="6">
        <span>换课总差价:</span>
      </el-col>
      <el-col :span="18">
        <span>C{{dataIn.changeCourseDifferentPriceTotal|toCurrency}}</span>
      </el-col>
    </el-row>
    <el-row v-if="!!dataIn.changeCourseRefundPriceTotal">
      <el-col :span="6">
        <span>退款总差价:</span>
      </el-col>
      <el-col :span="18">
        <span>C{{dataIn.changeCourseRefundPriceTotal|toCurrency}}</span>
      </el-col>
    </el-row>
    
    <el-row v-show="!!dataIn.bonusPointAmount" class="cs-redLabel">
    <el-col :span="6">
        <span>使用积分:</span>
      </el-col>
      <el-col :span="18">
        <span>-C{{dataIn.bonusPointAmount|toCurrency}}</span>
      </el-col>
    </el-row>
    <el-row v-show="!!dataIn.cashDecreased" class="cs-redLabel">
      <el-col :span="6">
        <span>现金减:</span>
      </el-col>
      <el-col :span="18">
        <span>-C{{(dataIn.cashDecreased)|toCurrency}}</span>
      </el-col>
    </el-row>
    <el-row v-show="!!dataIn.couponDiscountDollar" class="cs-redLabel">
      <el-col :span="6">
        <span>优惠劵:</span>
      </el-col>
      <el-col :span="18">
        <span>-C{{(dataIn.couponDiscountDollar)|toCurrency}}</span>
      </el-col>
    </el-row>
    <el-row v-if="dataIn.taxModel.hasTax">
      <el-col :span="6">
        <span>税前合计:</span>
      </el-col>
      <el-col :span="18">
        <span>C{{dataIn.accountDiscountAmount|toCurrency}}</span>
      </el-col>
    </el-row>
    <el-row v-if="dataIn.courseType == 1 && (dataIn.memberCardModel.hasBuyMemberCard || dataIn.isMember)">
      <el-col :span="6">
        <span class="cs-bold cs-color-darkred">双倍积分:</span>
      </el-col>
      <el-col :span="18">
        <el-checkbox v-if="!isReadOnly" v-model="dataIn.taxModel.isDoubleBonusPoint" class="input-width" @change="onDoubleBonusPointChange"></el-checkbox>
        <span v-else>{{dataIn.taxModel.isDoubleBonusPoint ? "是": "否"}}</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="6">
        <span>税费(HST:{{ dataIn.taxModel.taxRate | toPercent}}):</span>
      </el-col>
      <el-col :span="18">
        <el-checkbox v-if="dataIn.taxModel.hasTaxSetting && !isReadOnly" v-model="dataIn.taxModel.hasTax" class="input-width" @change="onHasTaxChange"></el-checkbox>
        <span v-if="dataIn.taxModel.hasTax">C{{(dataIn.taxModel.courseTotalTax)|toCurrency}}</span>
      </el-col>
    </el-row>
    <el-row v-if="!!dataIn.balanceInStore">
      <el-col :span="6">
        <span>已存余额:</span>
      </el-col>
      <el-col :span="18">
        <span>C{{dataIn.balanceInStore|toCurrency}}</span>
      </el-col>
    </el-row>
    <el-row v-show="!!dataIn.enrollmentCountAmount" class="cs-redLabel">
      <el-col :span="6">
        <span>使用占位:</span>
      </el-col>
      <el-col :span="18">
        <span>-C{{dataIn.enrollmentCountAmount|toCurrency}}</span>
      </el-col>
    </el-row>
    <el-row v-show="!!dataIn.balance" class="cs-redLabel">
      <el-col :span="6">
        <span>使用余额:</span>
      </el-col>
      <el-col :span="18">
        <span>-C{{dataIn.balance|toCurrency}}</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="6">
        <span>总计:</span>
      </el-col>
      <el-col :span="18">
        <span>C{{dataIn.accountAmount|toCurrency}}</span>
      </el-col>
    </el-row>
    <el-row v-show="!!dataIn.totalPayment" class="cs-redLabel">
      <el-col :span="6">
        <span>已付金额:</span>
      </el-col>
      <el-col :span="18">
        <span>-C{{(dataIn.totalPayment)|toCurrency}}</span>
      </el-col>
    </el-row>
    <el-row v-if="!!excessAmount">
      <el-col :span="6">
        <span>超出金额:</span>
      </el-col>
      <el-col :span="18">
        <span>C{{excessAmount|toCurrency}}</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="6">
        <span>应付价格:</span>
      </el-col>
      <el-col :span="18">
        <span>C{{accountAmountLeft|toCurrency}}</span>
      </el-col>
    </el-row>
    <el-row v-if="isSupplement">
      <el-col :span="6">
        <span>备注:</span>
      </el-col>
      <el-col :span="18">
        <span>{{dataIn.comments}}</span>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
.edit-button {
  padding: 0px;
  margin-left: 10px;
}
.el-row{
  margin-bottom: 5px;
}
</style>

<script>
export default {
  props: {
    isReadOnly: Boolean,
    isSupplement: Boolean,
    dataIn: {
      courseType:Number,
      discountName:String,
      courseDiscountList:Array,
      memberCardModel:{
        hasBuyMemberCard:Boolean,
        memberCardDiscountPrice:Number,
      },
      memberCardPrice:Number,
      courseCount:Number,
      courseOriginalPrice:Number,//课程总原价
      courseTotalDiscountPrice:Number,//总课程折扣价,不含补看视频
      courseTotalPrice:Number,//课程总应付
      supplementVideoTotalPrice:Number,//总看视频价格
      courseTotalDecreaseAmount:Number,
      workflowRelatedDicountAmount: Number,
      workflowRelatedDicountDetail: String,
      changeCourseDifferentPriceTotal:Number,
      changeCourseRefundPriceTotal:Number,
      enrollmentCountAmount:Number,
      balanceInStore:Number,
      balance:Number,
      bonusPointAmount:Number,
      cashDecreased:Number,
      couponDiscountDollar: Number,
      accountDiscountAmount: Number,
      accountAmount:Number,
      totalPayment:Number,
      courseList:Array,
      comments:String,
      taxModel:Object,
      isContinuePayment: Boolean,
      debt: Number,
      hasCouponDiscount: Boolean,
      isMember: Boolean
    }
  },
  data() {
    return {

    };
  },
  components: {},
  created() {
    this.init();
  },
  computed: {
    accountAmountLeft:function(){
      if (this.dataIn.isContinuePayment){
        return this.dataIn.debt;
      }
      let value = this.dataIn.accountAmount - this.dataIn.totalPayment;
      if (value < 0){
        value = 0;
      }
      return value;
    },
    excessAmount:function(){
      let value = this.dataIn.totalPayment - this.dataIn.accountAmount;
      if (value < 0){
        value = 0;
      }
      return value;
    },
    //总课程折扣价,不含补看视频
    courseTotalDiscountPrice: function() {
      let value = 0;
      if (this.dataIn && this.dataIn.courseList){
        this.dataIn.courseList.forEach(element => {
          value += element.priceData.discountPrice;
        });
      }
      return value;
    },
    //学生代理折后总课程价
    courseTotalCouponDiscountPrice: function() {
      let value = 0;
      if (this.dataIn && this.dataIn.courseList){
        this.dataIn.courseList.forEach(element => {
          value += element.priceData.couponDiscountPrice;
        });
      }
      return value;
    },
    //按折扣比例排序的课程列表
    sortedCourseList: function() {
      if (!this.dataIn || !this.dataIn.courseList) {
        return [];
      }

      return this.dataIn.courseList.slice().sort((a, b) => {
        const ratioA = a.priceData.discountPrice / a.priceData.price;
        const ratioB = b.priceData.discountPrice / b.priceData.price;
        return ratioA - ratioB; // 从小到大排序
      });
    },
  },
  methods: {
    init(){
  
    },
    onHasTaxChange(){
      this.$emit("hasTaxChange", this.dataIn.taxModel.hasTax);
    },
    onDoubleBonusPointChange(){
      this.$emit("isDoubleBonusPointChange", this.dataIn.taxModel.isDoubleBonusPoint);
    },
    calculateDiscount(price, discountPrice) {
      // 验证输入
      if (isNaN(price) || isNaN(discountPrice) || price < 0 || discountPrice < 0) {
          throw new Error("价格必须为有效的正数");
      }
      
      if (discountPrice > price) {
          throw new Error("折扣价不能高于原价");
      }
      
      if (price == 0 || discountPrice == price
        || (discountPrice >= price - 0.1 && discountPrice <= price + 0.1)
      ){
        return "";
      }

      // 计算折扣比例
      const discountRate = (discountPrice / price) * 10;
      // 格式化折扣显示
      let discountText;
      if (discountRate % 1 === 0) {
          // 如果是整数折扣
          discountText = `${discountRate.toFixed(0)}折`;
      } else {
          // 如果是小数折扣，去掉小数点显示
          discountText = `${(discountRate * 10).toFixed(0)}折`;
      }
      
      return discountText;
    }
  },
  watch: {
    dataIn: function(){
      this.init();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/addCollectFees/courseEnrollmentFee/workflowInfo.vue